import React, { useMemo } from 'react';
import { format, isToday, isYesterday } from 'date-fns';
import { styled } from '@components-shared/src/stitches';
import { DataTestId } from '@utils/test';

/**
 * This Divider will render a formatted date if passed a value as date
 * IF no value is passed, it will render the default divider
 */

const DIVIDER_DATE_FORMAT = 'LLLL dd';

export const getFormattedDate = (date: Date | undefined | null): string | null => {
  if (!date) return null;

  const dateString = format(date, DIVIDER_DATE_FORMAT);

  if (isToday(date)) {
    return `Today, ${dateString}`;
  } else if (isYesterday(date)) {
    return `Yesterday, ${dateString}`;
  } else {
    return dateString;
  }
};

export const Divider = ({ date }: { date?: Date }) => {
  const formattedDate = useMemo(() => getFormattedDate(date), [date]);

  return (
    <Container data-testid={DataTestId.FEED_DIVIDER}>
      <Line />
      {!!date && <Date data-testid={DataTestId.FEED_DIVIDER_DATE}>{formattedDate}</Date>}
    </Container>
  );
};

const Container = styled('div', {
  width: '100%',
  height: '1px',
  overflow: 'visible',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  paddingY: 20,

  '@tablet': {
    paddingY: 40,
  },
});

const Date = styled('div', {
  position: 'absolute',
  kicker: 'XS',
  background: '$white',
  color: '$neutral400',
  textTransform: 'uppercase',
  paddingX: ' 1.25rem',
});

const Line = styled('div', {
  width: '100%',
  height: '1px',
  backgroundColor: '$neutral200',
  flexShrink: 0,
});
